// extracted by mini-css-extract-plugin
module.exports = {"circle":"PulsatingIcon_circle__SM_Mb","pulse":"PulsatingIcon_pulse__zWXht"};